import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getClientById, updateClient, deleteClient } from "../../../../components/http";
import ClientInfo from "./ClientInfo";
import ClientCars from "./ClientCars";
import style from "./EditClient.module.scss";
import HeaderInfo from "../../../../components/header/headerInfo";
import ConfirmationModal from "../../../../components/PopUps/ConfirmDeleteButton";
import { useTranslation } from "react-i18next";

const EditClient = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { client_id } = useParams();
  const [client, setClient] = useState(null);
  const [initialClient, setInitialClient] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const fetchClient = async () => {
      try {
        if (!client_id) return;
        const fetchedClient = await getClientById(client_id);
        if (fetchedClient) {
          setClient(fetchedClient);
          setInitialClient(fetchedClient);
        }
      } catch (error) {
        console.error(t("editClient.errors.loadingClient"), error);
      }
    };

    fetchClient();
  }, [client_id, t]);

  const handleEditClick = () => setIsEditing(!isEditing);

  const handleSave = async () => {
    if (!client || !initialClient) return;

    try {
      const changedFields = {};
      Object.keys(client).forEach((key) => {
        if (client[key] !== initialClient[key]) {
          changedFields[key] = client[key];
        }
      });

      if (Object.keys(changedFields).length === 0) {
        alert(t("editClient.alerts.noChanges"));
        return;
      }

      await updateClient({ client_id: client.id, values: changedFields });
      setIsEditing(false);
      alert(t("editClient.alerts.success"));
    } catch (error) {
      console.error(t("editClient.errors.savingClient"), error);
      alert(t("editClient.alerts.errorSaving"));
    }
  };

  const handleDeleteClient = async (id) => {
    await ConfirmationModal({
      title: t("editClient.popUp.delete"),
      text: t("editClient.popUp.deleteConfirm"),
      confirmButtonColor: "#d33",
      confirmButtonText: t("editClient.popUp.confirmButtonText"),
      cancelButtonText: t("editClient.popUp.cancelButtonText"),
      cancelButtonColor: "#3085d6",
      onConfirm: async () => {
        try {
          await deleteClient(id);
          navigate(-1);
        } catch (error) {
          console.error(t("editClient.errors.deletingClient"), error);
        }
      },
    });
  };

  if (!client) return <div>{t("editClient.loading")}</div>;

  return (
    <div className={style.clientContainer}>
      <HeaderInfo onEditClick={handleEditClick} onDelete={() => handleDeleteClient(client.id)} />
      <div className={style.container}>
        <ClientInfo client={client} isEditing={isEditing} onClientChange={setClient} />
        <ClientCars cars={client.cars} />
      </div>
      
      {isEditing && (
        <button className={style.saveButton} onClick={handleSave}>
          {t("editClient.saveChanges")}
        </button>
      )}
    </div>
  );
};

export default EditClient;
